
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { EloquaLinkedService } from 'app/model/linkedservice/eloqua.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'EloquaObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Eloqua_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Eloqua_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: EloquaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class EloquaObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
